import classNames from "classnames";
import { isEmpty } from "lodash";
import * as React from "react";
import { AnnotationItem } from "../../../sharedComponents/imageAnnotation/components/Annotation";
import { getCoordStylesPositions } from "../helper/getAnnotationCoord";
import * as styles from "./Point.less";

export interface PointProps {
    active: boolean;
}

export function Point(props: AnnotationItem & PointProps) {
    const { geometry, active } = props;
    if (isEmpty(geometry)) {
        return null;
    }
    return (
        <div
            style={getCoordStylesPositions(geometry)}
            className={classNames([styles.point, active ? styles.point_active : undefined])}
        />
    );
}
